export * from './global-page.module';
export * from './global-page.service';
